export default "__VITE_ASSET__DtdP9p2L__"